import React, { Component } from "react";
import User from "./User";
import NewUserModal from "./NewUserModal";
import Popup from "reactjs-popup";
import "./UsersPanel.scss";
import addUSer from "../../../assets/image/icon/addp white.png";

export default class UsersPanel extends Component {
  renderUsers = () => {
    if (!this.props.usersShared || this.props.usersShared.length === 0) return;
    return this.props.usersShared.map((share) => {
      return (
        <User
          alert={this.props.alert}
          key={share.receiver.username}
          userInfo={this.props.userInfo}
          share={share}
          removeUserShared={this.props.removeUserShared}
        />
      );
    });
  };

  renderBtnAddUser = () => {
    return (
      <button className="btn btn-add-user align-self-start">
        <div className="user-card-img add-user d-flex justify-content-center align-items-center">
          <img src={addUSer} alt="" />
        </div>
      </button>
    );
  };

  render() {
    return (
      <div className="col-12 mt-lg-5 mt-md-5 mt-sm-3 mt-3 mb-3">
        <div className="row mb-3">
          <div className="col-12 p-0">
            <h5>
              <span className="badge badge-primary">
                {this.props.usersShared && this.props.usersShared.length > 0
                  ? "Sharing With:"
                  : "Share Bookmarks:"}
              </span>
            </h5>
          </div>
        </div>
        <div className="row">
          {this.renderUsers()}
          <Popup
            contentStyle={{ width: "fit-content(500px)" }}
            lockScroll={true}
            className="animated fadeIn faster"
            trigger={this.renderBtnAddUser()}
            modal
            closeOnDocumentClick
            on="click"
          >
            {(close) => (
              <NewUserModal
                alert={this.props.alert}
                userInfo={this.props.userInfo}
                close={close}
                addUserShared={this.props.addUserShared}
              />
            )}
          </Popup>
        </div>
      </div>
    );
  }
}
